module.exports = __webpack_public_path__ + "organization.8d2d9034a9cff91a72257ad8e4e7fd56.svg";